'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Returns an array of hexadecimal string colors.
 */
var coolorsToHex = function coolorsToHex(url) {
  return url.replace(/^.+\/([^/]+)$/, '$1').split('-').map(function (hex) {
    return '#' + hex;
  });
};

exports.default = coolorsToHex;


//////////////////
// WEBPACK FOOTER
// ./~/coolors-to-hex/dist/index.js
// module id = 1865
// module chunks = 0